import { DataTableColumn } from "../datatable/DataTableTypes";
import Modal from "./Modal";
import { DataTable } from "../datatable/DataTable";
import ButtonTray from "./ButtonTray";

interface AddFormProps {
    data?: any | null;
    show: boolean;
    setShow: (show: boolean) => void;
    setManager?: (manager: any) => void;
    title?: any;
    columns?: DataTableColumn[]
    setId?: any;
    onSubmit?: any;
    isLoading?: boolean,
    customerFilter?: any
    rowIdAccessorList?: any,
    setSelectedRow?: any

}

const CommonSelectorModal: React.FC<AddFormProps> = ({ data, show, customerFilter, title, setShow, columns = [], setSelectedRow, onSubmit }) => {

    return (
        <>

            <Modal
                title={title}
                show={show}
                setShow={setShow}
                className="w-3/5  rounded-lg shadow-lg"
                fields={
                    <div
                        className="modal-body px-4 pt-4">
                        <DataTable
                            columns={columns}
                            actions={{
                                fetchAction: data,
                            }}
                            defaultFilter={{
                                pageNumber: 0,
                                pageSize: 8,
                                ...customerFilter
                            }}
                            renderOptions={{ skipUserSettingRender: true, skipButtonSectionRender: true, skipFilterButtonRender: true }}
                            appendFilterToUrl={false}
                            rowSelectionOptions={{
                                enableRowSelection: true,
                                onSelectionChange: (selectedRows) => {
                                    const [row] = Array.from(selectedRows);
                                    if (row) {
                                        setSelectedRow(row)
                                    }
                                },
                            }}
                        />

                        <div className="modal-footer border-t border-surface-5 px-4 py-2 flex justify-end gap-1">
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "cancel",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            type: "submit",
                                            onClick: onSubmit,
                                        },
                                        buttonType: "button",
                                    }
                                ]}
                                align={"end"}
                                gap={2}
                            />
                        </div>
                    </div>

                }
            />

        </>
    );
};

export default CommonSelectorModal;
